import {
    styled,
} from '@payright/web-components';

export const AddBankDetailsContainer = styled.div`

    .addBankDetails {
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 100%;
    }

    .page-description {
        margin-bottom: 16px;
    }

    .alert-section {
        margin-bottom: 16px;
    }
`;